var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"border text-stone-100 p-2 uppercase w-full text-2xl px-4 whitespace-nowrap",class:[
        _vm.tourClass,
        {
            'bg-black border-black': _vm.brand === 'pelican' && !_vm.disabled,
            'bg-blue-500 border-blue-500': _vm.brand === 'hydration' && !_vm.disabled,
            'bg-gray-300 border-gray-300': _vm.disabled,
        }
    ],attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }